import type { WidgetFactory } from '@examdojo/core/widget';
import { GraphpadWidget, GRAPHPAD_PRESETS } from './functions/graphpad';

/**
 * Register all available widgets with the factory.
 * Call this during app initialization.
 */
export function registerAllWidgets(factory: WidgetFactory): void {
  // Register widget types
  factory.register('graphpad', GraphpadWidget);

  // Register graphpad presets
  for (const preset of GRAPHPAD_PRESETS) {
    factory.registerPreset(preset);
  }
}
